import React, { useEffect } from "react";
import { connect } from 'react-redux'
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import { SketchPicker, Color } from "react-color";
import { colorHelper } from "../../../helpers/colorHelper";
import Popover from "@material-ui/core/Popover";
import { cmsActions } from "../../../store/actions/cms/cms.action";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import './ColorPickerStyles.css'


const TemplateColors = ({ usedColors, onClick, path }) => {
    const handleClick = (color) => {
        let newColor = color;
        if (!color.includes('#') && !color.includes('rgb') && !color.includes('rgba')) {
            newColor = colorHelper.colourNameToHex(color);
            if (!newColor) return;
        }
        let convertedColor = isHex(newColor) ? colorHelper.hexToRgb(newColor) : colorHelper.rgbToObject(newColor);

        onClick({ hex: '', rgb: convertedColor }, newColor, path)
    }
    const isHex = (color) => {
        if (color.toString().includes('#')) return true;
        return false;
    }
    const filterColors = (colors) => {
        return Array.from(new Set([...colors]));
    }
    const colors = filterColors(usedColors)
    return (
        <React.Fragment>
            <FormGroup>
                <Label for="exampleEmail" className="temp-color-label"><SystemLabel name="ColorsInTemplate" /></Label>
                <div className="color-toolbar-container">
                    {colors.map((c, i) => {
                        return <div key={i} className="color-box-wrapper">
                            <span>
                                <div onClick={() => handleClick(c)} style={{ backgroundColor: c }} className="color-box"></div>
                            </span>
                        </div>
                    })}
                </div>
            </FormGroup>
        </React.Fragment >
    );
};
function mapStateToProps(state) {
    return {
        usedColors: state.template.usedColors
    };
}
export default connect(mapStateToProps)(TemplateColors);